"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactResponsive = require("react-responsive");

var _reactIntl = require("react-intl");

var _reactRouterDom = require("react-router-dom");

var _Popover = require("../../../../../Popover");

var _StyledLayout = require("../../../../../StyledLayout");

var _Icon = _interopRequireDefault(require("../../../../../Icon"));

var _Elements = require("../../../../Elements");

var _SocialGroup = _interopRequireDefault(require("../../../../common/components/SocialGroup"));

var _Elements2 = require("./Elements");

var _constants = require("../../../../constants/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var PAGE_ENUM = {
  HOME: 'HOME',
  ABOUT: 'ABOUT',
  CONTACT: 'CONTACT'
};

var Topnav = function Topnav(_ref) {
  var aboutTop = _ref.aboutTop,
      contactTop = _ref.contactTop,
      websiteName = _ref.websiteName,
      publicUrl = _ref.publicUrl,
      visibilityOptions = _ref.visibilityOptions,
      socialMedia = _ref.socialMedia,
      username = _ref.username,
      scrollDomId = _ref.scrollDomId,
      colour = _ref.colour,
      layoutWidth = _ref.layoutWidth,
      intl = _ref.intl;

  var _useState = (0, _react.useState)(PAGE_ENUM.HOME),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1024px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });
  var triggerRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      overflowVisibility = _useState4[0],
      setOverflowVisibility = _useState4[1];

  var scrollElement = scrollDomId ? document.getElementById(scrollDomId) : window;
  var topnavPadding = (0, _react.useMemo)(function () {
    if (isTabletLandScape) {
      return 48;
    }

    if (isTabletPortrait) {
      return 24;
    }

    return 16;
  }, [isTabletLandScape, isTabletPortrait, isMobileLandScape]);
  (0, _react.useEffect)(function () {
    // eslint-disable-next-line no-unused-expressions
    scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.addEventListener('scroll', function () {
      var scrollElementTop = scrollDomId ? scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollTop : window.scrollY;

      if (scrollElementTop >= contactTop) {
        setActiveIndex(PAGE_ENUM.CONTACT);
        return;
      }

      if (scrollElementTop >= aboutTop) {
        setActiveIndex(PAGE_ENUM.ABOUT);
        return;
      }

      setActiveIndex(PAGE_ENUM.HOME);
    });
  }, [aboutTop, scrollElement]);

  var renderMobileNavItem = function renderMobileNavItem() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      fontColor: activeIndex === PAGE_ENUM.HOME ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
      portfolioForeground2: activeIndex !== PAGE_ENUM.HOME,
      onClick: function onClick() {
        return window.scrollTo(0, 0);
      },
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "portfolio.theme.topnav.link.home"
    })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      fontColor: activeIndex === PAGE_ENUM.ABOUT ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
      portfolioForeground2: activeIndex !== PAGE_ENUM.ABOUT,
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl),
      onClick: function onClick() {
        return scrollElement.scrollTo(0, aboutTop);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "portfolio.theme.topnav.link.about"
    }))), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      fontColor: activeIndex === PAGE_ENUM.CONTACT ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
      portfolioForeground2: activeIndex !== PAGE_ENUM.CONTACT,
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl),
      onClick: function onClick() {
        return scrollElement.scrollTo(0, contactTop);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "portfolio.theme.topnav.link.contact"
    }))));
  };

  return /*#__PURE__*/_react["default"].createElement(_Elements2.TopnavBox, {
    flex: true,
    align: "center",
    padding: topnavPadding,
    width: layoutWidth
  }, isDesktopSmall && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements2.NavBox, {
    flex: true
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    fontColor: activeIndex === PAGE_ENUM.HOME ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour],
    portfolioForeground2: activeIndex !== PAGE_ENUM.HOME,
    bold: activeIndex === PAGE_ENUM.HOME,
    large: true,
    mr: "lg",
    onClick: function onClick() {
      return scrollElement.scrollTo(0, 0);
    },
    style: {
      cursor: 'pointer'
    },
    hasHover: true
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.TopnavLink, {
    to: "".concat(publicUrl),
    afterContent: intl.formatMessage({
      id: 'portfolio.theme.topnav.link.home'
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.home"
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    fontColor: activeIndex === PAGE_ENUM.ABOUT ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour],
    portfolioForeground2: activeIndex !== PAGE_ENUM.ABOUT,
    bold: activeIndex === PAGE_ENUM.ABOUT,
    large: true,
    mr: "lg",
    hasHover: true
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.TopnavLink, {
    to: "".concat(publicUrl),
    onClick: function onClick() {
      return scrollElement.scrollTo(0, aboutTop);
    },
    afterContent: intl.formatMessage({
      id: 'portfolio.theme.topnav.link.about'
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.about"
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    fontColor: activeIndex === PAGE_ENUM.CONTACT ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour],
    portfolioForeground2: activeIndex !== PAGE_ENUM.CONTACT,
    bold: activeIndex === PAGE_ENUM.CONTACT,
    large: true,
    hasHover: true
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.TopnavLink, {
    to: "".concat(publicUrl),
    onClick: function onClick() {
      return scrollElement.scrollTo(0, contactTop);
    },
    afterContent: intl.formatMessage({
      id: 'portfolio.theme.topnav.link.contact'
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.contact"
  })))), /*#__PURE__*/_react["default"].createElement(_Elements.Logo, {
    bold: true,
    portfolioForeground1: true,
    uppercase: true,
    style: {
      flex: 1,
      cursor: 'pointer'
    },
    center: true,
    onClick: function onClick() {
      return scrollElement.scrollTo(0, 0);
    },
    colour: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, websiteName), /*#__PURE__*/_react["default"].createElement(_Elements2.SocialBox, {
    flex: true,
    align: "center",
    justify: "right"
  }, /*#__PURE__*/_react["default"].createElement(_SocialGroup["default"], {
    socialMedia: socialMedia,
    visibilityOptions: visibilityOptions,
    username: username,
    spacing: "lg",
    fontColor: colour
  }))), !isDesktopSmall && /*#__PURE__*/_react["default"].createElement(_Elements2.MobileTopnavBox, {
    flex: true,
    align: "center",
    justify: "space-between",
    fullWidth: true,
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, /*#__PURE__*/_react["default"].createElement(_Elements.Logo, {
    portfolioForeground1: true,
    bold: true,
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return scrollElement.scrollTo(0, 0);
    }
  }, websiteName), /*#__PURE__*/_react["default"].createElement(_Popover.Popover, {
    id: "portfolio-moodie-mobile-topnav-popover",
    render: renderMobileNavItem(),
    triggerRef: triggerRef,
    onClickout: function onClickout() {
      return setOverflowVisibility(false);
    },
    triggerShow: function triggerShow() {
      return setOverflowVisibility(true);
    },
    popoverNestedRole: "dialog",
    alignment: "flex-end",
    position: "bottom-left",
    width: 174,
    show: overflowVisibility
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center",
    pointer: true,
    triggerRef: triggerRef,
    onClick: function onClick() {
      return setOverflowVisibility(!overflowVisibility);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    mr: "xs",
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour],
    bold: true,
    clampedSingleLine: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: {
      HOME: 'portfolio.theme.topnav.link.home',
      ABOUT: 'portfolio.theme.topnav.link.about',
      CONTACT: 'portfolio.theme.topnav.link.contact'
    }[activeIndex]
  })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronDown",
    size: "xs"
  })))));
};

Topnav.defaultProps = {
  websiteName: '',
  publicUrl: '/',
  socialMedia: {
    website: '',
    instagram: '',
    facebook: '',
    twitter: ''
  },
  visibilityOptions: {
    location: 'VISIBLE',
    pxProfile: 'VISIBLE',
    instagram: 'VISIBLE',
    facebook: 'VISIBLE',
    twitter: 'VISIBLE'
  },
  username: '',
  scrollDomId: '',
  colour: '',
  layoutWidth: 0
};
Topnav.propTypes = {
  aboutTop: _propTypes["default"].number.isRequired,
  contactTop: _propTypes["default"].number.isRequired,
  websiteName: _propTypes["default"].string,
  publicUrl: _propTypes["default"].string,
  socialMedia: _propTypes["default"].shape({
    website: _propTypes["default"].string,
    instagram: _propTypes["default"].string,
    facebook: _propTypes["default"].string,
    twitter: _propTypes["default"].string
  }),
  visibilityOptions: _propTypes["default"].shape({
    location: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    pxProfile: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    instagram: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    facebook: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    twitter: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN'])
  }),
  username: _propTypes["default"].string,
  scrollDomId: _propTypes["default"].string,
  colour: _propTypes["default"].string,
  layoutWidth: _propTypes["default"].number,
  intl: _propTypes["default"].shape().isRequired
};

var _default = (0, _reactIntl.injectIntl)(Topnav);

exports["default"] = _default;